import { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Collapse, IconButton, Typography, useTheme } from '@mui/material';

import EquipoPlayerLineupMode from '../equipos/jugadores/EquipoPlayerLineupMode';

const PlayersLineup = ({ players, title, mode, subMode, onClick }) => {
    const theme = useTheme();
    const [open, setOpen] = useState(true);

    if (players?.length > 0) {
        return (
            <Box border={`1px solid ${theme.palette.border.main}`} borderRadius={1}>
                <Box
                    onClick={() => setOpen(!open)}
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    pl={1}
                    height={25}
                    bgcolor="background.darkCard"
                    borderBottom={`1px solid ${theme.palette.border.main}`}
                >
                    <Typography fontWeight={500} fontSize={14}>
                        {title}
                    </Typography>
                    <IconButton>
                        {open ? <ExpandMoreIcon fontSize="small" /> : <ExpandLessIcon fontSize="small" />}
                    </IconButton>
                </Box>
                <Collapse in={open}>
                    <Box display={'flex'} flexWrap={'wrap'} width={'100%'}>
                        {players?.map((player, index) => (
                            <EquipoPlayerLineupMode
                                player={player}
                                key={index}
                                mode={mode}
                                subMode={subMode}
                                banquillo={true}
                                onClick={onClick}
                            />
                        ))}
                    </Box>
                </Collapse>
            </Box>
        );
    }
};

export default PlayersLineup;
